import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function EventsBanner() {

  const [EventsBanner, setEventsBanner] = useState([]);

  useEffect(() => {
    const fetchEventsBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/events/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setEventsBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchEventsBanner();
  }, []);

  return (
    <div
      className="common-banner-sec common-flex-center events-banner"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + EventsBanner.banner_image
          })`,
      }}
    >
      <div className="overlay"></div>
      <Container fluid>
        <Row className="common-flex-center">
          <Col md={8}>
            <div className=" ">
              <h1 className="common-head whiteColor">
                {" "}
                {EventsBanner.banner_title}
              </h1>
              <p className="common-para whiteColor">
                {EventsBanner.banner_description}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default EventsBanner;
